import {
  SiPython, SiJavascript, SiOpenjdk, SiCplusplus, SiPhp, SiDart, SiMysql,
  SiCodeigniter, SiReact, SiNodedotjs, SiExpress, SiFlutter, SiTensorflow, SiPytorch,
  SiScikitlearn, SiOpencv, SiMariadb, SiPostgresql, SiMongodb, SiFirebase,
  SiAmazonwebservices, SiAwslambda, SiAmazondynamodb, SiGit, SiDocker, SiGithubactions,
  SiPostman, SiJupyter, SiFigma, SiPm2, SiHtml5, SiCss3,
} from "react-icons/si";
import { TbApi, TbMail } from "react-icons/tb";

export const skillGroups = [
  {
    key: "languages",
    title: "Languages",
    items: [
      { name: "Python", icon: SiPython, color: "#3776AB" },
      { name: "JavaScript", icon: SiJavascript, color: "#F7DF1E" },
      { name: "PHP", icon: SiPhp, color: "#777BB4" },
      { name: "Dart", icon: SiDart, color: "#0175C2" },
      { name: "Java", icon: SiOpenjdk, color: "#ED8B00" },
      { name: "C++", icon: SiCplusplus, color: "#00599C" },
      { name: "SQL", icon: SiMysql, color: "#4479A1" },
    ],
  },
  {
    key: "frameworks",
    title: "Frameworks & Libraries",
    items: [
      { name: "CodeIgniter 4", icon: SiCodeigniter, color: "#EF4223" },
      { name: "React.js", icon: SiReact, color: "#61DAFB" },
      { name: "Node.js", icon: SiNodedotjs, color: "#5FA04E" },
      { name: "Express.js", icon: SiExpress, color: "#ffffff" },
      { name: "Flutter", icon: SiFlutter, color: "#02569B" },
      { name: "TensorFlow", icon: SiTensorflow, color: "#FF6F00" },
      { name: "PyTorch", icon: SiPytorch, color: "#EE4C2C" },
      { name: "Scikit-learn", icon: SiScikitlearn, color: "#F7931E" },
      { name: "OpenCV", icon: SiOpencv, color: "#5C3EE8" },
      { name: "HTML5", icon: SiHtml5, color: "#E34F26" },
      { name: "CSS3", icon: SiCss3, color: "#1572B6" },
    ],
  },
  {
    key: "data",
    title: "Databases & Cloud",
    items: [
      { name: "MariaDB", icon: SiMariadb, color: "#C0765A" },
      { name: "MySQL", icon: SiMysql, color: "#4479A1" },
      { name: "PostgreSQL", icon: SiPostgresql, color: "#4169E1" },
      { name: "MongoDB", icon: SiMongodb, color: "#47A248" },
      { name: "Firebase", icon: SiFirebase, color: "#FFCA28" },
      { name: "AWS", icon: SiAmazonwebservices, color: "#FF9900" },
      { name: "AWS Lambda", icon: SiAwslambda, color: "#FF9900" },
      { name: "AWS SES", icon: TbMail, color: "#FF9900" },
      { name: "DynamoDB", icon: SiAmazondynamodb, color: "#4053D6" },
    ],
  },
  {
    key: "tools",
    title: "Tools & Practices",
    items: [
      { name: "Git", icon: SiGit, color: "#F05032" },
      { name: "Docker", icon: SiDocker, color: "#2496ED" },
      { name: "CI/CD", icon: SiGithubactions, color: "#2088FF" },
      { name: "REST APIs", icon: TbApi, color: "#b8a4ff" },
      { name: "Postman", icon: SiPostman, color: "#FF6C37" },
      { name: "Jupyter", icon: SiJupyter, color: "#F37626" },
      { name: "Figma", icon: SiFigma, color: "#F24E1E" },
      { name: "PM2", icon: SiPm2, color: "#2B037A" },
    ],
  },
];

// Bukti pemakaian: skill -> di proyek/peran mana dipakai
export const proofOfWork = [
  {
    skill: "CodeIgniter 4 + MariaDB",
    context: "Multi-tenant ERP, schema sync across tenants, compliance validation",
    where: ["Qibris ERP KB", "CV Perdana Teknosindo"],
  },
  {
    skill: "REST / Host-to-Host API",
    context: "CEISA 4.0 customs documents with fail-safe revert-to-draft",
    where: ["Qibris ERP KB"],
  },
  {
    skill: "Python + OpenCV",
    context: "Offline face recognition at 0.6 ms per detection",
    where: ["RECCA"],
  },
  {
    skill: "Mask R-CNN",
    context: "Food segmentation & calorie estimation, 78% accuracy — published",
    where: ["FoodKcal", "JIPI 2024"],
  },
  {
    skill: "Flutter + TensorFlow Lite",
    context: "On-device, offline image classification",
    where: ["Durian Detector"],
  },
  {
    skill: "React + Express + Firebase",
    context: "Role-based booking, QRIS payments, QR validation",
    where: ["Government Building Rental System"],
  },
  {
    skill: "AWS & cloud services",
    context: "Backend and cloud services, +50% scalability",
    where: ["KADA Demo Day prototype"],
  },
];
